import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// Update Email
export default function EmailModal(props: any) {
  const newEmail = React.createRef<HTMLInputElement>();
  return (
    <Modal {...props}>
      <Modal.Header>
        <Modal.Title>Update Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={(e) => newEmail.current && props.onSubmit(e, { email: newEmail.current.value })}
          onReset={props.onHide}
          name="email"
        >
          <div className={"form-row"}>
            <label className={"form-label"} htmlFor={"new-email"}>
              New Email
            </label>
            <input
              id={"new-email"}
              className={"form-control"}
              type="email"
              title="Enter a new email"
              ref={newEmail}
              required
            />
          </div>
          <div className="button-group">
            <Button type="submit" variant="outline-primary">
              Update Email
            </Button>
            <Button type="reset" variant="outline-secondary">
              Cancel
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
